import { render, staticRenderFns } from "./ApptConfirm.vue?vue&type=template&id=6358de87&"
import script from "./ApptConfirm.vue?vue&type=script&lang=js&"
export * from "./ApptConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports